import createApi from '../../utils/createApi';
import createProviderOptions from './createProviderOptions';
import sendRequest from './sendRequest';
import receiveResponse from './receiveResponse';

export default function createAxiosProvider(options) {
  return createApi({
    createProviderOptions,
    receiveResponse,
    sendRequest,
    ...options,
  });
}
